import { render, staticRenderFns } from "./SkuByBaseBoardSuppler.vue?vue&type=template&id=5d3e65c8&scoped=true&"
import script from "./SkuByBaseBoardSuppler.vue?vue&type=script&lang=js&"
export * from "./SkuByBaseBoardSuppler.vue?vue&type=script&lang=js&"
import style0 from "./SkuByBaseBoardSuppler.vue?vue&type=style&index=0&id=5d3e65c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3e65c8",
  null
  
)

export default component.exports